export const LOAD_CUENTAS_BANCARIAS = 'LOAD_CUENTAS_BANCARIAS';
export const SET_CUENTAS_BANCARIAS = 'SET_CUENTAS_BANCARIAS';

export const SAVE_CUENTA_BANCARIA = 'SAVE_CUENTA_BANCARIA';
export const SAVED_CUENTA_BANCARIA = 'SAVED_CUENTA_BANCARIA';

export const loadCuentasBancarias = () => ({
    type: LOAD_CUENTAS_BANCARIAS,
});

export const setCuentasBancarias = (cuentasBancarias) => ({
    type: SET_CUENTAS_BANCARIAS,
    cuentasBancarias,
});

export const saveCuentaBancaria = (cuentaBancaria) => ({
    type: SAVE_CUENTA_BANCARIA,
    cuentaBancaria,
});

export const savedCuentaBancaria = (cuentaBancaria) => ({
    type: SAVED_CUENTA_BANCARIA,
    cuentaBancaria,
});

const initialState = {
    cuentasBancarias: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
    case SAVED_CUENTA_BANCARIA: {
        const { cuentaBancaria } = action;
        const index = state.cuentasBancarias.findIndex((item) => item.id === cuentaBancaria.id);
        if (index === -1) {
            return {
                ...state,
                cuentasBancarias: state.cuentasBancarias.concat(cuentaBancaria),
            };
        }
        const updated = state.cuentasBancarias
            .slice(0, index)
            .concat([cuentaBancaria])
            .concat(state.cuentasBancarias.slice(index + 1));
        return {
            ...state,
            cuentasBancarias: updated,
        };
    }
    case SET_CUENTAS_BANCARIAS: {
        const { cuentasBancarias } = action;
        return {
            ...state,
            cuentasBancarias,
        };
    }
    default:
        return state;
    }
};
